// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb6fbd26","239":"f1b23649","453":"a4684b91","455":"73fa9c18"}[chunkId] + ".chunk.js";
};